import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Naming It (Without Arguing)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I recognize it: this is perfectionism. Not just “high standards” — fear."
    ],
      [
      "Daily intention: Today I recognize it: this is perfectionism. Not just “high standards” — fear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “I’m afraid to make mistakes — so I demand perfection.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “I’m afraid to make mistakes — so I demand perfection.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I want to be “perfect” right now?\n[Write here]",
      "What am I afraid will happen if it’s only “okay”?\n[Write here]",
      "Where do I feel this fear in my body?\n[Write here]"
    ],
      [
      "What do I want to be “perfect” right now?\n[Write here]",
      "What am I afraid will happen if it’s only “okay”?\n[Write here]",
      "Where do I feel this fear in my body?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Today I don’t fight perfectionism. I recognize it."
    ],
      [
      "Closing",
      "Today I don’t fight perfectionism. I recognize it."
    ]
    ),
    action: localizedGenderNode(
      "Once today: one breath + the sentence: “Perfection is fear in disguise.”",
      "Once today: one breath + the sentence: “Perfection is fear in disguise.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Fact vs. Demand (Gentle CBT)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check what is truly required — and what I demand to avoid feeling exposed."
    ],
      [
      "Daily intention: Today I check what is truly required — and what I demand to avoid feeling exposed."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Not everything has to be 100%.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Not everything has to be 100%.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is truly required here? (real minimum)\n[Write here]",
      "What is the perfectionist demand above that?\n[Write here]",
      "What gentle truth is possible here? (one sentence)\n[Write here]"
    ],
      [
      "What is truly required here? (real minimum)\n[Write here]",
      "What is the perfectionist demand above that?\n[Write here]",
      "What gentle truth is possible here? (one sentence)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "High demand is not proof of quality — sometimes it’s proof of fear."
    ],
      [
      "Closing",
      "High demand is not proof of quality — sometimes it’s proof of fear."
    ]
    ),
    action: localizedGenderNode(
      "I define a “real minimum” for one task.",
      "I define a “real minimum” for one task."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Fear of Mistakes (And What It Says About Me)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the fear of mistakes — without letting it stop me."
    ],
      [
      "Daily intention: Today I touch the fear of mistakes — without letting it stop me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What mistake am I most afraid of making?\n[Write here]",
      "What do I tell myself it would mean about me if I make it?\n[Write here]",
      "What other truth could exist? (Mistake = …)\n[Write here]"
    ],
      [
      "What mistake am I most afraid of making?\n[Write here]",
      "What do I tell myself it would mean about me if I make it?\n[Write here]",
      "What other truth could exist? (Mistake = …)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A mistake is an event. Not an identity."
    ],
      [
      "Closing",
      "A mistake is an event. Not an identity."
    ]
    ),
    action: localizedGenderNode(
      "Once today I say: “It’s allowed to make mistakes on the way.”",
      "Once today I say: “It’s allowed to make mistakes on the way.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Procrastination as “Protection”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand: procrastination is not laziness. It’s an attempt to protect me from pain."
    ],
      [
      "Daily intention: Today I understand: procrastination is not laziness. It’s an attempt to protect me from pain."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m not lazy. I’m afraid.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m not lazy. I’m afraid.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I postponing right now?\n[Write here]",
      "What is the postponement protecting me from? (criticism / shame / failure / exposure)\n[Write here]",
      "What small possible version of starting exists?\n[Write here]"
    ],
      [
      "What am I postponing right now?\n[Write here]",
      "What is the postponement protecting me from? (criticism / shame / failure / exposure)\n[Write here]",
      "What small possible version of starting exists?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When I respect the fear — I can start small."
    ],
      [
      "Closing",
      "When I respect the fear — I can start small."
    ]
    ),
    action: localizedGenderNode(
      "I do a 2-minute start. Just 2 minutes.",
      "I do a 2-minute start. Just 2 minutes."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "“Perfect or Nothing”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I recognize extreme thinking and bring back the middle."
    ],
      [
      "Daily intention: Today I recognize extreme thinking and bring back the middle."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “There is also a middle.”"
    ],
      [
      "I pause with myself.",
      "One breath. “There is also a middle.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I think “perfect or nothing”?\n[Write here]",
      "What is the cost of this extremity?\n[Write here]",
      "What does a “middle version” sound like? (one sentence)\n[Write here]"
    ],
      [
      "Where do I think “perfect or nothing”?\n[Write here]",
      "What is the cost of this extremity?\n[Write here]",
      "What does a “middle version” sound like? (one sentence)\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The middle is where life gets built."
    ],
      [
      "Closing",
      "The middle is where life gets built."
    ]
    ),
    action: localizedGenderNode(
      "I choose a 70% version for one task.",
      "I choose a 70% version for one task."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Inner Critic Holding a Whip",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice the tone — and stop letting it lead."
    ],
      [
      "Daily intention: Today I notice the tone — and stop letting it lead."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “The tone doesn’t have to be violent.”"
    ],
      [
      "I pause with myself.",
      "One breath. “The tone doesn’t have to be violent.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does the critic tell me to “motivate” me?\n[Write here]",
      "What does this do to my body / motivation?\n[Write here]",
      "How would I speak to a loved friend to help them move forward?\n[Write here]"
    ],
      [
      "What does the critic tell me to “motivate” me?\n[Write here]",
      "What does this do to my body / motivation?\n[Write here]",
      "How would I speak to a loved friend to help them move forward?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A whip doesn’t build stability. It builds fear."
    ],
      [
      "Closing",
      "A whip doesn’t build stability. It builds fear."
    ]
    ),
    action: localizedGenderNode(
      "I replace one violent sentence with one human sentence.",
      "I replace one violent sentence with one human sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Progress Experiment (Behavior): 10% Is a Win",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice a small action — even if it’s not perfect."
    ],
      [
      "Daily intention: Today I practice a small action — even if it’s not perfect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What big goal makes me freeze?\n[Write here]",
      "What is 10% of it that I can do today?\n[Write here]",
      "What do I want to prove to myself through 10%?\n[Write here]"
    ],
      [
      "What big goal makes me freeze?\n[Write here]",
      "What is 10% of it that I can do today?\n[Write here]",
      "What do I want to prove to myself through 10%?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t need motivation to start. I need a start."
    ],
      [
      "Closing",
      "I don’t need motivation to start. I need a start."
    ]
    ),
    action: localizedGenderNode(
      "I do my 10%. That’s all.",
      "I do my 10%. That’s all."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Tolerating Uncertainty (ACT): “Maybe It Won’t Be Perfect — And I Do It”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice acting despite uncertainty."
    ],
      [
      "Daily intention: Today I practice acting despite uncertainty."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Uncertainty is the cost of living.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Uncertainty is the cost of living.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid will happen if it’s not perfect?\n[Write here]",
      "One-minute practice: I let the fear be here without fixing it.\nWhat happened after the minute?\n[Write here]",
      "What did I learn about the wave?\n[Write here]"
    ],
      [
      "What am I afraid will happen if it’s not perfect?\n[Write here]",
      "One-minute practice: I let the fear be here without fixing it.\nWhat happened after the minute?\n[Write here]",
      "What did I learn about the wave?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I’m brave not because fear is gone — but because I act with it."
    ],
      [
      "Closing",
      "I’m brave not because fear is gone — but because I act with it."
    ]
    ),
    action: localizedGenderNode(
      "One minute only. Consistency > force.",
      "One minute only. Consistency > force."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“What Will They Say” and Shame",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand that perfectionism is often fear of exposure."
    ],
      [
      "Daily intention: Today I understand that perfectionism is often fear of exposure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who “sits in my head” when I want to be perfect?\n[Write here]",
      "What am I afraid they’ll judge me for?\n[Write here]",
      "What gentle truth do I choose about myself today?\n[Write here]"
    ],
      [
      "Who “sits in my head” when I want to be perfect?\n[Write here]",
      "What am I afraid they’ll judge me for?\n[Write here]",
      "What gentle truth do I choose about myself today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to be perfect to be worthy."
    ],
      [
      "Closing",
      "I don’t have to be perfect to be worthy."
    ]
    ),
    action: localizedGenderNode(
      "Once today: “I’m doing this for me, not for the committee.”",
      "Once today: “I’m doing this for me, not for the committee.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Compassion Instead of Pressure (Self-Compassion)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I hold myself like someone I love."
    ],
      [
      "Daily intention: Today I hold myself like someone I love."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I can move forward without stepping on myself.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I can move forward without stepping on myself.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would I say to a loved friend frozen by perfectionism?\n[Write here]",
      "Which one sentence am I willing to say to myself?\n[Write here]",
      "Where is it hardest for me to be gentle with myself?\n[Write here]"
    ],
      [
      "What would I say to a loved friend frozen by perfectionism?\n[Write here]",
      "Which one sentence am I willing to say to myself?\n[Write here]",
      "Where is it hardest for me to be gentle with myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Compassion doesn’t lower standards — it lowers fear."
    ],
      [
      "Closing",
      "Compassion doesn’t lower standards — it lowers fear."
    ]
    ),
    action: localizedGenderNode(
      "Hand on chest/belly + my gentle sentence once.",
      "Hand on chest/belly + my gentle sentence once."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Boundaries for Time and Loops",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I set one boundary against endless polishing."
    ],
      [
      "Daily intention: Today I set one boundary against endless polishing."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “Enough is also a decision.”"
    ],
      [
      "I pause with myself.",
      "One breath. “Enough is also a decision.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I get stuck polishing endlessly?\n[Write here]",
      "What small time boundary am I willing to set? (15–30 min)\n[Write here]",
      "What am I afraid will happen if I stop on time?\n[Write here]"
    ],
      [
      "Where do I get stuck polishing endlessly?\n[Write here]",
      "What small time boundary am I willing to set? (15–30 min)\n[Write here]",
      "What am I afraid will happen if I stop on time?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary protects life — it’s not giving up quality."
    ],
      [
      "Closing",
      "A boundary protects life — it’s not giving up quality."
    ]
    ),
    action: localizedGenderNode(
      "I work in a limited time — and stop on time.",
      "I work in a limited time — and stop on time."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Practicing “First Version”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I practice releasing a “Version 1” without apologizing."
    ],
      [
      "Daily intention: Today I practice releasing a “Version 1” without apologizing."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I waiting to be “ready” for a long time?\n[Write here]",
      "What counts as a minimal “Version 1”?\n[Write here]",
      "What would actually happen if I release Version 1?\n[Write here]"
    ],
      [
      "What am I waiting to be “ready” for a long time?\n[Write here]",
      "What counts as a minimal “Version 1”?\n[Write here]",
      "What would actually happen if I release Version 1?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Version 1 is not shame. It’s a beginning."
    ],
      [
      "Closing",
      "Version 1 is not shame. It’s a beginning."
    ]
    ),
    action: localizedGenderNode(
      "I release one thing as Version 1 (even just to myself).",
      "I release one thing as Version 1 (even just to myself)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Building the Identity of Someone Who Moves Forward",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I choose to be a person who progresses — not one who proves."
    ],
      [
      "Daily intention: Today I choose to be a person who progresses — not one who proves."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I’m on the way.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I’m on the way.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What value do I want to lead me? (growth / truth / calm / courage)\n[Write here]",
      "What small habit serves this value this week?\n[Write here]",
      "What do I promise myself on a stuck day?\n[Write here]"
    ],
      [
      "What value do I want to lead me? (growth / truth / calm / courage)\n[Write here]",
      "What small habit serves this value this week?\n[Write here]",
      "What do I promise myself on a stuck day?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t wait to be perfect to be myself."
    ],
      [
      "Closing",
      "I don’t wait to be perfect to be myself."
    ]
    ),
    action: localizedGenderNode(
      "I plan one small step for next week — and put it in my calendar.",
      "I plan one small step for next week — and put it in my calendar."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure (Leaving the Cage)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I end the journey not with a “victory” — with freedom."
    ],
      [
      "Daily intention: Today I end the journey not with a “victory” — with freedom."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath. “I choose life.”"
    ],
      [
      "I pause with myself.",
      "One breath. “I choose life.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I understand about my perfectionism?\n[Write here]",
      "What changed in me, even a little, during this journey?\n[Write here]",
      "Return sentence for hard days (short, clear, pocket-sized):\n[Write here]"
    ],
      [
      "What did I understand about my perfectionism?\n[Write here]",
      "What changed in me, even a little, during this journey?\n[Write here]",
      "Return sentence for hard days (short, clear, pocket-sized):\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I don’t cancel my desire for quality.",
      "I cancel the violence that keeps me stuck.",
      "I keep walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I don’t cancel my desire for quality.",
      "I cancel the violence that keeps me stuck.",
      "I keep walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "I choose one action that symbolizes “I started”: 10 minutes of work / sending / opening a file.",
      "I choose one action that symbolizes “I started”: 10 minutes of work / sending / opening a file."
    ),
  },
].map(buildNormalizedDay);

export const perfectionismFearOfMistakesProcrastinationBlueprintEn = buildNormalizedPilotBlueprint({
  id: "perfectionism_fear_of_mistakes_procrastination_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "perfectionism_fear_of_mistakes_procrastination",
  category: "general",
  journeyName: {
    he: "פרפקציוניזם שמוביל לפחד מטעויות ודחיינות",
    en: "Perfectionism Leading to Fear of Mistakes and Procrastination",
    es: "Perfeccionismo que lleva al miedo a equivocarse y a la procrastinación",
  },
  days,
});

export default perfectionismFearOfMistakesProcrastinationBlueprintEn;
